import React, { memo } from "react";
import {useEffect, useRef} from "react";


function TaskCard({
  task,
  editingTaskId,
  editForm,
  setEditForm,
  startEdit,
  saveEdit,
  cancelEdit,
  toggleComplete,
  deleteTask,
  isOverdue,
  getPriorityColor
}) {
    const inputRef = useRef(null);
    useEffect(() => {
        if (editingTaskId === task.id) {
            inputRef.current?.focus();
        }
    }, [editingTaskId, task.id]);

  return (
    <div
      className={`card ${task.completed ? "completed" : ""} ${
        isOverdue(task.dueDate) && !task.completed ? "overdue" : ""
      }`}
      style={{ borderLeft: `7px solid ${getPriorityColor(task.priority)}` }}
    >
        {editingTaskId === task.id ? (
        <div className="edit-form">
            <input
            className="input edit-title"
            ref={inputRef}
            value={editForm.title}
            onChange={(e) =>
                setEditForm({ ...editForm, title: e.target.value })
            }
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    if (editForm.title.trim()) saveEdit(task.id);
                }
                if (e.key === "Escape") {
                    cancelEdit();
                }
            }}
            />

            <input
            className="input edit-desc"
            value={editForm.description}
            onChange={(e) =>
                setEditForm({ ...editForm, description: e.target.value })
            }
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    if (editForm.title.trim()) saveEdit(task.id);
                }
                if (e.key === "Escape") {
                    cancelEdit();
                }
            }}
            />

            <select
            className="input edit-row"
            value={editForm.priority}
            onChange={(e) =>
                setEditForm({ ...editForm, priority: e.target.value })
            }
            >
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
            </select>

            <input
            type="date"
            className="input"
            value={editForm.dueDate}
            onChange={(e) =>
                setEditForm({ ...editForm, dueDate: e.target.value })
            }
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    if (editForm.title.trim()) saveEdit(task.id);
                }
                if (e.key === "Escape") {
                    cancelEdit();
                }
            }}
            />

            <button className="button edit-actions primary" onClick={() => saveEdit(task.id)} disabled={!editForm.title.trim()}>
            Save
            </button>

            <button className="button edit-actions delete" onClick={cancelEdit}>
            Cancel
            </button>
        </div>
        ) : null}

        
        <h3 style={{margin: "0 0 5px 0", textDecoration: task.completed ? "line-through" : "none"}}>
        {task.title}
        </h3>

        <p className="meta">
        {task.priority.charAt(0).toUpperCase() + task.priority.slice(1)}
        {task.dueDate && (
            <>
            {" • "}
            {new Date(task.dueDate + "T00:00:00").toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
            })}
            </>
        )}

        {isOverdue(task.dueDate) && !task.completed && (
            <span className="overdue-badge">Overdue</span>
        )}
        </p>

        {task.description && 
        (<p style={{margin: "0 0 10px 0"}}>{task.description}</p>
        )}

        {editingTaskId !== task.id && (
        <div className="action-row">
            <button onClick={() => startEdit(task)} className="button">
            Edit
            </button>

            <button onClick={() => toggleComplete(task.id, task.completed)} className={`button ${task.completed ? "success" : "primary"}`}>
            {task.completed ? "Undo" : "Complete"}
            </button>

            <button onClick={() => deleteTask(task.id)} className="button delete">
            Delete
            </button>
        </div>
        )}  
    </div>
  );
}

export default memo(TaskCard);